import React, { Component } from "react";
import { connect } from "react-redux";
import { Form, Grid, Header, Segment, Label } from "semantic-ui-react";

import { resetPassword } from "../../actions/password/reset";
import SystemHeader from "../components/system_header";
import Button from "../components/button";
import "../../App.css";

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
    };

    this.isFormSubmitted = false;
  }

  onReset = () => {
    this.isFormSubmitted = true;
    this.props.reset(this.state.email);
  };

  render() {
    const isSuccessShown = this.isFormSubmitted && !this.props.pending && !this.props.resetFailure;
    const isInvalidShown = this.isFormSubmitted && !this.props.pending && this.props.resetFailure;
    const isFormShown = this.isFormSubmitted ? !isSuccessShown : true;

    return (
      <React.Fragment>
        <SystemHeader showMenu={false} showLoading={false} />
        <div className="reset-password-form" style={{ marginTop: "3rem" }}>
          <Grid textAlign="center" style={{ height: "100%" }} verticalAlign="middle">
            <Grid.Column style={{ maxWidth: 450 }}>
              {isFormShown && (
                <div>
                  <Header as="h2" textAlign="center" className="theme-font-color">
                    Reset your password
                  </Header>
                  <Form size="large">
                    <Segment padded>
                      <Form.Input
                        fluid
                        icon="user"
                        iconPosition="left"
                        placeholder="Email address"
                        type="email"
                        onChange={(event) => this.setState({ email: event.target.value })}
                      />
                      <Button loading={this.props.pending} fluid size="large" onClick={this.onReset}>
                        Submit
                      </Button>
                    </Segment>
                  </Form>
                </div>
              )}
              {isSuccessShown && (
                <Header as="h4" textAlign="center" className="theme-font-color">
                  <p>Reset password link was sent to your email.</p>
                  <Button href="/">
                    Login
                  </Button>
                </Header>
              )}
              {isInvalidShown && (
                <React.Fragment>
                  <br />
                  <label className="alert alert-danger">Please enter a valid email address.</label>
                </React.Fragment>
              )}
            </Grid.Column>
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    resetFailure: state.reset_password.resetFailure,
    pending: state.reset_password.pending,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reset: (email) => {
      dispatch(resetPassword(email));
    },
  };
};

let ResetPasswordPage = connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
export default ResetPasswordPage;



// WEBPACK FOOTER //
// ./src/views/password/reset.js